import { createRoot, type Root } from 'react-dom/client';
import Masthead from './components/Masthead';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import WorksSection from './components/WorksSection';
import PhilosophySection from './components/PhilosophySection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import Mastfoot from './components/Mastfoot';
import ParticleCanvas from './components/ParticleCanvas';
import ScrollTicks from './components/ScrollTicks';


function App() {
  return (
    <div className="relative isolate flex flex-col items-start w-full">
      <Masthead />

      <main className="relative z-9 flex w-full flex-col gap-16">
        <HeroSection />
        <ServicesSection />
        <WorksSection />
        <PhilosophySection />
        <AboutSection />
        <ContactSection />
        <ScrollTicks />
      </main>

      <Mastfoot />
      <ParticleCanvas />
    </div>
  );
}

declare global {
  interface Window {
    __avarisRoot?: Root;
  }
}

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container #root not found');
}

const root = window.__avarisRoot ?? createRoot(container);
window.__avarisRoot = root;
root.render(<App />);
